import React from "react";
import "./OurInstructors.css";

const OurInstructors = () => {
  return (
    <div className="instructors-container">
      <div className="section-header">
        <h2 className="section-heading animated" data-animation="bounceInUp">
          Our Instructors
        </h2>
        <p className="subheading">
          Senior Instructors under the guidance of Master Suresh Rao
        </p>
      </div>
      <div className="team-wrapper">
        <div className="team-member">
          <figure className="member-photo">
            <img src="images/member2.jpg" alt="Ms. Tara Kumari" />
          </figure>
          <div className="team-detail">
            <h4>Ms. Tara Kumari</h4>
            <span className="role">Chief Instructor</span>
            <p>
              Ms. Tara Kumari, a seasoned practitioner with over 35 years of
              experience, has earned numerous accolades at the state and
              national levels since 1992. A distinguished Black Belt holder and
              senior student, she shares her expertise by conducting classes in
              various educational institutions and international schools.
            </p>
            <p>
              Her commitment to teaching has inspired countless students to
              master the art and achieve excellence.
            </p>
          </div>
        </div>

        <div className="team-member">
          <figure className="member-photo">
            <img src="images/member3.jpg" alt="Mr. Renu Prasad" />
          </figure>
          <div className="team-detail">
            <h4>Mr. Renu Prasad</h4>
            <span className="role">Chief Instructor</span>
            <p>
              Mr. Renu Prasad, a highly skilled practitioner with 27 years of
              dedicated experience, has earned prestigious State and National
              titles. A senior student and accomplished Black Belt holder, he
              conducts classes across various educational institutions.
            </p>
            <p>
              His passion for teaching and commitment to excellence make him an
              inspiring mentor for students of all levels.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OurInstructors;